export default __webpack_public_path__ + "static/media/facebook.65533af9.svg";